import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicyMain = () => {
  return (
    <div style={{ padding: "40px", maxWidth: "800px", margin: "0 auto", fontFamily: "Arial, sans-serif", textAlign: "center" }}>
      <h1 style={{ color: "#4527A0", marginBottom: "30px" }}>Select App for Privacy Policy</h1>
      
      <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "40px" }}>
        <Link to="/dailyflow-privacyPolicy">
          <button style={{ 
            padding: "15px 30px", 
            backgroundColor: "#4285F4", 
            color: "white", 
            border: "none", 
            borderRadius: "4px", 
            fontSize: "16px",
            cursor: "pointer",
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
          }}>
            DailyFlow
          </button>
        </Link>
        
        <Link to="/komunity-privacyPolicy">
          <button style={{ 
            padding: "15px 30px", 
            backgroundColor: "#FF5722", 
            color: "white", 
            border: "none", 
            borderRadius: "4px", 
            fontSize: "16px",
            cursor: "pointer",
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
          }}>
            Komunity
          </button>
        </Link>
        
        <Link to="/yikjeolbot-privacyPolicy">
          <button style={{ 
            padding: "15px 30px", 
            backgroundColor: "#4CAF50", 
            color: "white", 
            border: "none", 
            borderRadius: "4px", 
            fontSize: "16px",
            cursor: "pointer",
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
          }}>
            익절봇
          </button>
        </Link>
        
        <Link to="/EquityNote-privacyPolicy">
          <button style={{ 
            padding: "15px 30px", 
            backgroundColor: "#9C27B0", 
            color: "white", 
            border: "none", 
            borderRadius: "4px", 
            fontSize: "16px",
            cursor: "pointer",
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
          }}>
            매매일지
          </button>
        </Link>
      
      </div>
      
      <p style={{ color: "#666", fontSize: "14px" }}>
        Please select the app for which you want to view the privacy policy. Each app has its own specific privacy policy.
      </p>
    </div>
  );
};

export default PrivacyPolicyMain;